
import GLightbox from 'glightbox';

class Lightbox {
    constructor() {
        this.initLightbox();
    }
    initLightbox(){
        const lightbox = GLightbox({
            type: 'video',
            selector: ".js-video__link"
        });
    }
}
export default Lightbox;